import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Receipt } from 'lucide-react';
import { useAppSelector } from '@/app/hooks';
import { TransactionHistory } from './TransactionHistory';
import { TransactionDetails } from './TransactionDetails';
import { useIsLandscape } from '@/hooks/useMediaQuery';

/**
 * 11 Transaksi. Phone: list → full-screen detail. Landscape: 460px master list + inline detail.
 * Deep link from a notification: /transactions?receipt=XXX
 */
export const TransactionsPage: React.FC = () => {
    const { t } = useTranslation();
    const isLandscape = useIsLandscape();
    const { selectedShop } = useAppSelector((state) => state.auth);
    const [selected, setSelected] = useState<string | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const receipt = searchParams.get('receipt');
        if (receipt) {
            setSelected(receipt);
            setSearchParams({}, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    if (!selectedShop) return null;

    return (
        <div className="flex h-full min-h-0 flex-1">
            <TransactionHistory selected={selected} onSelect={setSelected} autoSelectFirst={isLandscape} className="lg:w-[460px] lg:flex-none lg:border-r lg:border-line-subtle" />
            {isLandscape ? (
                selected ? (
                    <TransactionDetails key={selected} receiptNumber={selected} shopId={selectedShop.shopId} onClose={() => setSelected(null)} inline />
                ) : (
                    <div className="flex flex-1 flex-col items-center justify-center gap-2 text-center text-ink-muted">
                        <Receipt className="h-10 w-10 text-primary-200" />
                        <p className="text-sm font-bold">{t('transactions.selectHint')}</p>
                    </div>
                )
            ) : (
                selected && <TransactionDetails key={selected} receiptNumber={selected} shopId={selectedShop.shopId} onClose={() => setSelected(null)} />
            )}
        </div>
    );
};

export default TransactionsPage;
